import { SvgProps } from '@pancakeswap/uikit'

const GradientLogo: React.FC<React.PropsWithChildren<SvgProps>> = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_b_24_99)">
        <g filter="url(#filter1_i_24_99)">
          <g clipPath="url(#clip0_24_99)">
            <g filter="url(#filter2_i_24_99)">
              <path
                d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7451 10.7452 0 24 0C37.2548 0 48 10.7451 48 24Z"
                fill="#2C9EF0"
              />
            </g>
            <g filter="url(#filter3_i_24_99)">
              <path
                d="M42.4188 23.9999C42.4188 33.7666 34.1725 41.6841 24.0001 41.6841C13.8278 41.6841 5.58154 33.7666 5.58154 23.9999C5.58154 14.2331 13.8278 6.31567 24.0001 6.31567C34.1725 6.31567 42.4188 14.2331 42.4188 23.9999Z"
                fill="#405AE2"
              />
            </g>
            <g filter="url(#filter4_d_24_99)">
              <path
                d="M35.7207 24C35.7207 30.2787 30.473 35.3684 23.9997 35.3684C17.5264 35.3684 12.2788 30.2787 12.2788 24C12.2788 17.7214 17.5264 12.6316 23.9997 12.6316C30.473 12.6316 35.7207 17.7214 35.7207 24Z"
                fill="#877DF3"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_24_99"
          x="-4"
          y="-4"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_24_99" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_24_99" result="shape" />
        </filter>
        <filter
          id="filter1_i_24_99"
          x="0"
          y="0"
          width="48"
          height="52"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_24_99" />
        </filter>
        <filter
          id="filter2_i_24_99"
          x="0"
          y="0"
          width="48"
          height="140.216"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="92.2162" />
          <feGaussianBlur stdDeviation="46.1081" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_24_99" />
        </filter>
        <filter
          id="filter3_i_24_99"
          x="5.58154"
          y="6.31567"
          width="36.8374"
          height="127.585"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="92.2162" />
          <feGaussianBlur stdDeviation="46.1081" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_24_99" />
        </filter>
        <filter
          id="filter4_d_24_99"
          x="-79.9374"
          y="12.6316"
          width="207.874"
          height="207.169"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="92.2162" />
          <feGaussianBlur stdDeviation="46.1081" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24_99" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_24_99" result="shape" />
        </filter>
        <clipPath id="clip0_24_99">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>

    // <Svg viewBox="0 0 48 48" {...props}>
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M14.9024 0C10.8947 0 7.87179 3.60289 8.60749 7.50271L10.3484 16.7306C4.45101 19.3061 0 23.7533 0 29.3333V32.7273C0 37.3405 3.08306 41.2029 7.39317 43.8102C11.7369 46.4379 17.6132 48 24 48C30.3868 48 36.2631 46.4379 40.6068 43.8102C44.9169 41.2029 48 37.3405 48 32.7273V29.3333C48 23.7236 43.5028 19.2593 37.5552 16.6889L39.2882 7.50271C40.0239 3.6029 37.001 0 32.9933 0C29.4567 0 26.5896 2.83809 26.5896 6.33904V14.147C25.7386 14.0899 24.8746 14.0606 24 14.0606C23.0897 14.0606 22.1908 14.0923 21.3061 14.1541V6.33904C21.3061 2.83809 18.4391 0 14.9024 0ZM17.8776 28.3637C17.8776 30.372 16.7811 32 15.4286 32C14.0761 32 12.9796 30.372 12.9796 28.3637C12.9796 26.3554 14.0761 24.7273 15.4286 24.7273C16.7811 24.7273 17.8776 26.3554 17.8776 28.3637ZM34.7757 28.3637C34.7757 30.372 33.6792 32 32.3267 32C30.9742 32 29.8777 30.372 29.8777 28.3637C29.8777 26.3554 30.9742 24.7273 32.3267 24.7273C33.6792 24.7273 34.7757 26.3554 34.7757 28.3637Z"
    //     fill="url(#paint0_linear)"
    //   />
    //   <defs>
    //     <linearGradient id="paint0_linear" x1="24" y1="0" x2="24" y2="48" gradientUnits="userSpaceOnUse">
    //       <stop stopColor="#7645D9" />
    //       <stop offset="1" stopColor="#5121B1" />
    //     </linearGradient>
    //   </defs>
    // </Svg>
  )
}

export default GradientLogo
